/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { Copy } from 'sushiweb/Icons';
import { green } from 'sushiweb/tokens/color';

export default function CopyMessage({ details }) {
  const [isCopied, setCopied] = useState(false);
  if (!details || !details.text) {
    return null;
  }
  return (
    <div
      css={`
        color: ${details?.color || '#333'};
        width: ${details?.width || '100%'};
        margin-bottom: '4rem';
        display: flex;
        justify-content: space-between;
        align-items: center;
      `}
      onClick={() => {
        navigator.clipboard.writeText(details.text);
        setCopied(true);
      }}
    >
      <span
        css={`
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 82%;
          font-weight: ${details?.font_weight || '500'};
          font-size: ${details?.font_size || '1.2rem'};
          text-align: ${details?.text_align || 'justify'};
          word-spacing: ${details?.word_spacing || 'normal'};
        `}
      >
        {details.text}
      </span>
      {isCopied ? (
        <p className='tw-text-green-700 tw-font-medium tw-text-200'>copied</p>
      ) : (
        <span className='copyIcon tw-cursor-pointer'>
          <Copy size={15} color={green.z700} />
        </span>
      )}
    </div>
  );
}
